import { render, staticRenderFns } from "./tiscMessage.vue?vue&type=template&id=5fc739ca&"
import script from "./tiscMessage.vue?vue&type=script&lang=js&"
export * from "./tiscMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports